import React, { Fragment, Component } from 'react'
import Select from 'react-select'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import CreateBloc from './Blocs/CreateBloc'
import CustomSelect from'../../../../helpers/ui/CustomSelect'

var reformatEmployee = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.employee_nip+" - "+region.employee_name;
      newObj["value"] = region.employee_uuid;
      newObj["model"] = region;
      return newObj;
    });
};

var reformatOptions = function(raw, label, value) {
    return raw.map(function(data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];
  
      return newObj;
    });
};

class IndexView extends Component {

    createBloc = new CreateBloc();

    constructor(props) {
        super(props)
        this.state = {
            optionTipe : [
                { label: "Manajerial", value: "1" },
                { label: "Teknis", value: "2" },
                { label: "Sosio Kultural", value: "3" }
            ],
            optionLevel: [
                { value: 'chocolate', label: 'Chocolate' },
                { value: 'strawberry', label: 'Strawberry' },
                { value: 'vanilla', label: 'Vanilla' }
              ],
            optionCategories: [],
            dataForm: {},
            levelComps: [
                {
                    name: "",
                    level : 1
                },
            ],
            EmpComps: [
                {
                    euuid: "",
                    idx : 1
                },
            ],
            jenisdokumen : [
                {value:'1',label:'Dokumen Pelantikan'},
                {value:'2',label:'Pakta Integritas'},
                {value:'3',label:'Dokumen SPP, SPMJ, SPMT'},
            ],
            selectStates : [],
            selectPelantik : null,
            selectRohaniawan : null,
            selectSaksi1 : null,
            selectSaksi2 : null,
            selectDoctype : null,
            slcpenandatangan : null
        }
    }

    addLevel = () => {
        let count = this.state.levelComps.length;
        this.setState({
            levelComps: [
                ...this.state.levelComps,
                {
                    name : "",
                    level : count == 0 ? (count+1) : this.state.levelComps.slice(-1)[0].level + 1
                }
            ]
        })

        console.log(this.state.levelComps)
    }
    addEmp = () => {
        let count = this.state.EmpComps.length;
        this.setState({
            EmpComps: [
                ...this.state.EmpComps,
                {
                    euuid : "",
                    idx : count == 0 ? (count+1) : this.state.EmpComps.slice(-1)[0].idx + 1
                }
            ]
        })

        console.log(this.state.EmpComps)
    }

    delLevel = (data) => {
        let count = this.state.levelComps.length-1;
        this.setState({
            levelComps: [
                ...this.state.levelComps.filter((val) => val!=data)
                
                // (count-1)
            ]
        })
    }
    delEmp = (data) => {
        let count = this.state.EmpComps.length-1;
        this.setState({
            EmpComps: [
                ...this.state.EmpComps.filter((val) => val!=data)
                
                // (count-1)
            ]
        })
    }

    reformatLevel = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["name"] = data.level_name;
          newObj["level"] = data.level_no;
      
          return newObj;
        });
    }
    reformatEmp = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["euuid"] = data.level_name;
          newObj["idx"] = data.level_no;
      
          return newObj;
        });
    }

    handleSelectChange = (selectedOption, index) => {
        const newSelectStates = [...this.state.selectStates];
        newSelectStates[index] = selectedOption;
        this.setState({ selectStates: newSelectStates });
      };
    handleSelectChangepelantik = (selectedOption) => {
        this.setState({ selectpelantik: selectedOption.value });
      };
    
    handleRemoveSelect = (index) => {
        const newSelectStates = this.state.selectStates.filter((_, i) => i !== index);
        this.setState({ selectStates: newSelectStates });
        
    };

    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm)
    }

    handleChangeInputLevel = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.levelComps];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.name = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({levelComps : items});
    }
    handleChangeInputEmp = (e, index) => {
        console.log(e);
        // 1. Make a shallow copy of the items
        let items = [...this.state.EmpComps];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.euuid = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({EmpComps : items});
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        console.log(values)
        // return 

        this.setState({
            dataForm: values,
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.createBloc.listPegawaiChanel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            employeeItems: reformatEmployee(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.fetchPegawai()

        this.createBloc.listJabatanChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ positionOption: result.data.response.result, loadingPosition: false })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })
        this.createBloc.fetchListJabatan()
        // get data type
        // this.createBloc.accategoriesChannel.subscribe((result) => {
        //     switch (result.status) {
        //         case apiResponse.COMPLETED:
        //             if(result.data.status) {
        //                 let response = result.data.response
        //                 //console.log(response)
                        
        //                 this.setState({
        //                     optionCategories: reformatOptions(
        //                         response.result, 
        //                         'category_name',
        //                         'category_id'
        //                     )
        //                 })
        //             }
        //             break
        //         case apiResponse.ERROR:
                    
        //             break
        //         default:
        //             break
        //     }
        // })
        // this.createBloc.fetchCategories({})
    }
    
    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>Form Tambah Data Undangan Pelantikan </CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Form Inputan digunakan untuk melakukan generate 5 dokumen
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Pilih Jenis Dokumen <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <Select
                                                    required="required"
                                                    options={this.state.jenisdokumen}
                                                    onChange={selectedOption => this.setState({ selectDoctype: selectedOption.value })}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Jenis dokumen"
                                                />
                                                <AvField
                                                    type="hidden"
                                                    value={this.state.selectDoctype}
                                                    onChange={() => {}}
                                                    name="tipedokumen"
                                                />
                                            </Col>
                                        </Row> */}
                                        
                                                
                                            
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor Surat <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="nomor_surat"
                                                    placeholder="Nomor Surat Pelantikan..."
                                                    type="text"
                                                    className="form-control"
                                                    id="nomor_surat"
                                                    required="required"
                                                    validate={{ required: { value: true } }}
                                                    // value={this.state.dataForm.punishment_sk_date}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Surat <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="tanggal_surat"
                                                    placeholder="Tanggal surat..."
                                                    type="date"
                                                    className="form-control"
                                                    id="tanggal_surat"
                                                    required="required"
                                                    validate={{ required: { value: true } }}
                                                    // value={this.state.dataForm.punishment_sk_date}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Pelantikan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="tanggal_pelantikan"
                                                    placeholder="Tanggal Pelantikan..."
                                                    type="date"
                                                    className="form-control"
                                                    id="tanggal_pelantikan"
                                                    required="required"
                                                    validate={{ required: { value: true } }}
                                                    // value={this.state.dataForm.punishment_sk_date}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Waktu Mulai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="waktu_mulai"
                                                    placeholder="Wakktu Mulai Pelantikan..."
                                                    type="text" 
                                                    className="form-control"
                                                    id="waktu_mulai"
                                                    required="required"
                                                    validate={{ required: { value: true } }}
                                                    maxlength="8"
                                                    // value={this.state.dataForm.punishment_sk_date}
                                                    />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Waktu Selesai
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="waktu_selesai"
                                                    placeholder="Wakktu Selesai Pelantikan..."
                                                    type="text"
                                                    className="form-control"
                                                    id="waktu_selesai"
                                                    maxlength="8"
                                                    // value={this.state.dataForm.punishment_sk_date}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                           Lokasi Pelantikan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                  <AvField
                                                    name="lokasi"
                                                    placeholder="Lokasi Pelantikan (Kota pelantikan).."
                                                    type="text"
                                                    className="form-control"
                                                    id="lokasi"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                           Tempat Pelantikan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                  <AvField
                                                    name="tempat"
                                                    placeholder="Tempat Pelantikan (Nama tempat/Gedung pelantikan).."
                                                    type="text"
                                                    className="form-control"
                                                    id="tempat"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                           Pakaian <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                  <AvField
                                                    name="pakaian"
                                                    placeholder="Pakaian.."
                                                    type="text"
                                                    className="form-control"
                                                    id="pakaian"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <Label htmlFor="fieldGender" className="col-md-3 col-form-label">Pilih Pegawai<span className="text-danger">*</span></Label>
                                            <Col md="6">

                                                {
                                                    this.state.EmpComps.map((data, index) => {
                                                        return (
                                                            <div className="row">
                                                                <div className="col-md-10">
                                                                {/* <AvField
                                                                    name={`level[${index}]`}
                                                                    placeholder={`Level-${(index+1)}`}
                                                                    type="text"
                                                                    errorMessage="Masukkan Level"
                                                                    className="form-control mb-2"
                                                                    validate={{ required: { value: true } }}
                                                                    onChange={(e) => {
                                                                        this.handleChangeInputLevel(e, index)
                                                                    }}
                                                                    value={data.name}
                                                                /> */}
                                                                <Select
                                                                    name={`slcemployeuuid[${index}]`}
                                                                    // value={this.state.employeeItems.filter(option => 
                                                                    //   option.value === this.state.employeeSelected)}
                                                                    value={this.state.selectStates[index] || null}
                                                                    onChange={(e) => {
                                                                        this.handleSelectChange(e, index)
                                                                    }}
                                                                    validate={{ required: { value: true } }}
                                                                    options={this.state.employeeItems}
                                                                    classNamePrefix=""
                                                                    placeholder={`Pilih Pegawai-${index+1}`}
                                                                />
                                                                <AvField
                                                                    type="hidden"
                                                                    value={this.state.selectStates[index] ? this.state.selectStates[index].value : ''}
                                                                    onChange={() => {}}
                                                                    placeholder={`Hasil Opsi ${index + 1}`}
                                                                    name={`employeuuid[${index}]`}
                                                                />
                                                                </div>
                                                                <div className="col-md-2 text-right">
                                                                    {
                                                                        index == 0 ? 
                                                                        <div className="col-md-2 text-right">
                                                                            <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                                                                color="success" 
                                                                                type="button"
                                                                                onClick={this.addEmp}
                                                                                ><i className="uil-plus-circle"></i>
                                                                            </Button>
                                                                        </div> :
                                                                            <Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
                                                                                color="danger" 
                                                                                type="button"
                                                                                onClick={() => {
                                                                                    this.delEmp(data)
                                                                                    this.handleRemoveSelect(index)
                                                                                }}
                                                                                ><i className="uil-trash-alt"></i>
                                                                            </Button>
                                                                    }
                                                                    
                                                                </div>
                                                            </div>
                                                        )    
                                                    })
                                                }

                                                
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <label
                                                htmlFor=""
                                                className="col-md-3 col-form-label"
                                            >
                                            Saksi-1<span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                
                                            <Select
                                                    name="slcsaksi1"
                                                    onChange={selectedOption => this.setState({ selectSaksi1: selectedOption.value })}
                                                    validate={{ required: { value: true } }}
                                                    options={this.state.employeeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih saksi-1..."
                                                    />
                                                <AvField
                                                    type="hidden"
                                                    value={this.state.selectSaksi1}
                                                    onChange={() => {}}
                                                    placeholder="Pilih Pegawai"
                                                    name="saksi1uuid"
                                                    />
                                                
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                    >
                                                Saksi-2<span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    
                                                <Select
                                                        name="slcsaksi2"
                                                        onChange={selectedOption => this.setState({ selectSaksi2: selectedOption.value })}
                                                        validate={{ required: { value: true } }}
                                                        options={this.state.employeeItems}
                                                        classNamePrefix=""
                                                        placeholder="Pilih Saksi-2..."
                                                        />
                                                    <AvField
                                                        type="hidden"
                                                        value={this.state.selectSaksi2}
                                                        onChange={() => {}}
                                                        placeholder="Pilih Pegawai"
                                                        name="saksi2uuid"
                                                    />
                                                    
                                                </Col>
                                            </Row>
                                        <Row className="mb-3">
                                                <label
                                                    htmlFor=""
                                                    className="col-md-3 col-form-label"
                                                    >
                                                Penandatangan<span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    
                                                <Select
                                                        name="penandatangan"
                                                        onChange={selectedOption => this.setState({ slcpenandatangan: selectedOption.value })}
                                                        validate={{ required: { value: true } }}
                                                        options={this.state.employeeItems}
                                                        classNamePrefix=""
                                                        placeholder="Pilih Penandatangan..."
                                                        />
                                                    <AvField
                                                        type="hidden"
                                                        value={this.state.slcpenandatangan}
                                                        onChange={() => {}}
                                                        placeholder="Pilih Penandatangan"
                                                        name="penandatangan_uuid"
                                                    />
                                                    
                                                </Col>
                                            </Row>
                                        
                                            <hr />
                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/dokumen_pelantikan.html">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/undangan_pelantikan.html'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView